import {ConditionType} from '../enum/condition-type.enum';

export enum ConditionOperator {
  AND = 'AND',
  OR = 'OR'
}

export interface Condition {
  type: 'simple' | 'group' | 'subCondition';
}

export interface SimpleCondition extends Condition {
  type: 'simple';
  field: string;
  parentIndex?: number;
  operator: ConditionType;
  value?: any;
  isValid: boolean
  subCondition?: SubCondition;
  duplicableSectionId?: string;
}

export interface ConditionGroup extends Condition {
  type: 'group';
  operator: ConditionOperator;
  conditions: Array<Condition>;
  duplicableSectionId?: string;
}

export interface SubCondition extends Condition {
  type: 'subCondition';
  parentField: string;
  conditions: ConditionGroup;
  operator?: ConditionType;
  duplicableSectionId?: string;
}
